export default "__VITE_ASSET__zxELp2Bf__"